import React from 'react';

export type AvatarProps = {
  children: React.ReactNode | string;
};

const Avatar: React.FC<AvatarProps> = ({ children }: AvatarProps) => {
  return (
    <div className="flex relative summary-panel-avatar w-10 h-10 justify-center items-center m-1 mr-2 -ml-3 rounded-full text-lg">
      {children}
    </div>
  );
};

export default Avatar;
